import { Dayjs, OpUnitType, UnitType } from 'dayjs';
import { DateRange as DateRangeType } from '@mui/x-date-pickers-pro';

export class DateRangeLength {
  public static get(range: DateRangeType<Dayjs>, unit: UnitType | OpUnitType) {
    return range[0] && range[1] && range[1].add(1, 'day').diff(range[0], unit);
  }
}
